import type { Dayjs } from 'dayjs'
import uk from 'dayjs/locale/uk'

interface ICustomLocale extends Omit<ILocale, 'monthsShort' | 'weekdaysShort'> {
  weekdaysShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
  monthsShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
}

const locale: ICustomLocale = {
  ...uk,
  name: 'uk',
  weekStart: 1,
  weekdaysShort: (dayjsInstance: Dayjs, format: string): string => {
    const extended = 'Нд_Пн_Вт_Ср_Чт_Пт_Сб'.split('_')
    const standard = 'ндл_пнд_втр_срд_чтв_птн_сбт'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.day()]
    } else {
      return standard[dayjsInstance.day()]
    }
  },
  monthsShort: (dayjsInstance: Dayjs, format: string): string => {
    const extended = 'Січ._Лют._Бер._Квiт._Трав._Черв._Лип._Серп._Вер._Жовт._Лист._Груд.'.split('_')
    const standard = 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.month()]
    } else {
      return standard[dayjsInstance.month()]
    }
  }
}

export default locale
